import { Button } from '@mui/material';
import { useCountDown, useRequest } from 'ahooks';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { implog } from '@/api/implog';
import { recharge } from '@/api/recharge';
import IconClose from '@/assets/icon/icon_close_new.webp';
import IconLoading from '@/assets/icon/loading_content.webp';
import IconWifi from '@/assets/modal/wifi.webp';
import showNiceModal from '@/components/nice-modal';
import BlurryLoadingImage from '@/components/progressive-img';
import { toast } from '@/utils/toast';

import styles from './styles.module.less';

export const RechargeModal = (modal: any, onClose, innerProps) => {
  const { data, isGameing } = innerProps;
  const [showClose, setShowClose] = useState(false);
  const [targetDate, setTargetDate] = useState<number>();
  const { run, cancel, refresh } = useRequest(recharge, {
    manual: true,
    onSuccess: res => {
      modal.resolve({ ...res, onClose });
    },
    onError: error => {
      toast(error?.message || '');
      onClose();
    }
  });
  const [countdown] = useCountDown({
    targetDate,
    onEnd: () => {
      if (!showClose) {
        setShowClose(true);
        setTargetDate(Date.now() + 4000);
        return;
      }
      cancel();
      setShowClose(false);
      implog('recharge_modal_retry');

      showNiceModal(
        {
          width: '5.6rem',
          top: '20vh',
          maskClosable: false,
          closable: {
            hideClose: true
          },
          contentStyle: {
            background: '#272939'
          },
          render: (modal, onHide) => {
            return (
              <div className={styles.retryModal}>
                <BlurryLoadingImage className={styles.retryModalWifi} src={IconWifi} />
                <div className={styles.retryModalContent}>
                  The network is unstable.
                  <br />
                  Please Try Again.
                </div>
                <div className={styles.retryModalButtons}>
                  <Button
                    className={classNames(styles.retryModalButton, styles.retryModalButtonCancel)}
                    onClick={() => {
                      implog('recharge_modal_retry_cancel');
                      onClose?.();
                      onHide?.();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={classNames(styles.retryModalButton, 'global_button_succes')}
                    onClick={() => {
                      implog('recharge_modal_retry_click');
                      onHide?.();
                      setTargetDate(Date.now() + 5000);
                      let { from } = data;

                      if (from === undefined) {
                        from = isGameing ? 1 : 0;
                      }
                      refresh();
                    }}
                  >
                    Retry
                  </Button>
                </div>
              </div>
            );
          }
        },
        'recharge-loading-retry-modal'
      );
    }
  });

  useEffect(() => {
    setTargetDate(Date.now() + 5000);
    let { from } = data;

    if (from === undefined) {
      from = isGameing ? 1 : 0;
    }
    run({
      ...data,
      from
    });
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.loadingContent}>
        <img className={styles.loading} src={IconLoading} alt="" />
        <div>Loading...</div>
      </div>
      {showClose ? (
        <img
          onClick={() => {
            cancel();
            onClose();
          }}
          className={styles.close}
          src={IconClose}
          alt=""
        />
      ) : null}
    </div>
  );
};
export default RechargeModal;
